<!-- eslint-disable vue/no-unused-components -->
<template>
    <b-modal v-model="show" :title="'Remplacement d\'un thème à une campagne en cours'" :hide-footer="true">
        <b-overlay :show="fetchingCampaignChildren">
            <div class="flex" style="align-items: baseline">
                <b-row>
                    <b-col md="6">
                        <b-form-group>
                            <v-select id="selector" v-model="selected" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="label" :options="creas" :closeOnSelect="false"></v-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-button variant="primary" class="btn-icon" @click="updateCampaignCrea(selected)">
                    <feather-icon icon="UploadIcon" size="16" />
                </b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
    import RangeDate from './range-date.vue';
    import { mapGetters } from 'vuex';
    import { BRow, BCol, BFormGroup } from 'bootstrap-vue';

    import vSelect from 'vue-select';

    export default {
        components: {
            // eslint-disable-next-line vue/no-unused-components
            RangeDate,
            BRow,
            BCol,
            BFormGroup,
            vSelect,
        },
        data() {
            return {
                show: false,
                fetchingCampaignChildren: true,
                currentDate: '',
                creas: [],
                selected: '',
                campaignCode: '',
                childCampaign: null,
            };
        },
        computed: {
            ...mapGetters({
                formatToDate: 'app/formatToDate',
            }),
        },
        methods: {
            close() {
                this.currentDate = '';
                this.show = false;
                this.fetchingCampaignChildren = true;
            },
            async open(startDate, endDateRaw, code, pointCode) {
                this.$set(this, 'campaignCode', code);
                this.fetchingCampaignChildren = true;
                this.show = true;
                this.childCampaign = (await this.$store.dispatch('app/getCampaign', { campaignCode: code })).data;
                this.fetchCreaData(code);
                this.fetchingCampaignChildren = false;
            },

            fetchCreaData(code) {
                const brand = code.split('_')[1].toLowerCase();
                const creas = this.$store.dispatch('app/getCreaByBrand', `${brand}`).then((res) => {
                    this.$set(this, 'creas', res.data.data);
                });
            },
            async updateCampaignCrea(selected) {
                try {
                    this.$root.toggleGlobalLoading(true);
                    const data = {
                        creaCode: selected.crea_code,
                        creativeUrl: this.childCampaign.details?.crea?.url ?? '',
                    };
                    await this.$store.dispatch('app/updateProviderCampaign', { code: this.campaignCode, data });
                    this.$root.toggleGlobalLoading(false);
                    this.$toast({
                        component: 'toast',
                        props: {
                            title: 'Thème remplacer avec success',
                            icon: 'smile',
                            variant: 'success',
                        },
                    });
                    this.selected = 0;
                    this.show = false;
                } catch (error) {
                    console.error(error);
                    this.$toast({
                        component: 'toast',
                        props: {
                            title: 'Remplacement échoué',
                            icon: 'x-circle',
                            variant: 'danger',
                        },
                    });
                }
            },
        },
    };
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
    .flex {
        position: relative;
        width: 100%;
        display: flex;
        place-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
    }

    #selector {
        position: relative;
        min-width: 400px;
        flex-wrap: wrap;

        font-size: 13px;

        ul {
            border: 1px solid #404656;
            overflow-x: hidden;

            li {
                overflow-x: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 100%;
            }
        }
    }

    #selector .custom-select {
        overflow: hidden;
    }
</style>
